<template>
  <footer class="bg-stone-950 text-white">
    <div class="mx-auto max-w-7xl px-4 py-10 md:py-14">
      <div v-scroll-reveal="'fade-up'" class="rounded-[2rem] border border-white/10 bg-white/5 p-6 shadow-soft md:p-8">
        <div v-scroll-reveal-stagger="{ step: 100 }" class="grid gap-8 md:grid-cols-[1.15fr_0.85fr_0.85fr]">
          <div>
            <div class="flex items-center gap-3">
              <div class="grid h-11 w-11 place-items-center rounded-2xl bg-gradient-to-br from-brand-500 to-orange-400 text-lg font-semibold text-white">ฐ</div>
              <div>
                <div class="text-lg font-semibold">ฐิติมา พาณิชย์</div>
                <div class="text-sm text-stone-400">{{ t("footer.tagline") }}</div>
              </div>
            </div>
            <p class="mt-4 max-w-lg text-sm leading-7 text-stone-300">{{ t("footer.desc") }}</p>
            <div class="mt-5 flex flex-wrap gap-3">
              <a href="/#contact" class="rounded-full bg-brand-500 px-5 py-3 text-sm font-medium text-white shadow-float">
                {{ locale === "th" ? "ส่งรายละเอียดงาน" : "Send Job Details" }}
              </a>
              <a :href="LINE_URL" target="_blank" rel="noopener noreferrer" class="rounded-full border border-white/15 px-5 py-3 text-sm font-medium text-stone-200 transition hover:border-white/30 hover:text-white">
                {{ t("footer.lineAction") }}
              </a>
            </div>
          </div>

          <div>
            <div class="text-base font-semibold">{{ t("footer.menu") }}</div>
            <div class="mt-4 grid gap-3 text-sm text-stone-400">
              <component
                :is="item.to ? RouterLink : 'a'"
                v-for="item in localizedNavItems"
                :key="item.key"
                :to="item.to"
                :href="item.href"
                class="transition hover:text-white"
              >
                {{ item.label }}
              </component>
            </div>
          </div>

          <div>
            <div class="text-base font-semibold">{{ t("footer.contact") }}</div>
            <div class="mt-4 grid gap-4">
              <div class="rounded-[1.4rem] border border-white/10 bg-black/10 p-4">
                <div class="text-xs font-semibold uppercase tracking-[0.16em] text-stone-500">{{ t("footer.lineLabel") }}</div>
                <div class="mt-2 text-base font-semibold text-white">{{ t("footer.line") }}</div>
              </div>
              <div class="rounded-[1.4rem] border border-white/10 bg-black/10 p-4">
                <div class="text-xs font-semibold uppercase tracking-[0.16em] text-stone-500">{{ locale === "th" ? "Support" : "Support" }}</div>
                <div class="mt-2 text-sm leading-7 text-stone-300">{{ t("footer.supportHours") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-t border-white/10 py-4 text-center text-sm text-stone-500">{{ t("footer.copy") }}</div>
  </footer>
</template>

<script setup>
import { LINE_URL } from "../constants/line";
import { computed } from "vue";
import { RouterLink } from "vue-router";
import { useI18n } from "vue-i18n";

const props = defineProps({
  navItems: {
    type: Array,
    default: () => []
  }
});

const { locale, t } = useI18n();

const localizedNavItems = computed(() =>
  props.navItems.map((item) => ({
    ...item,
    label: item.label?.[locale.value] || item.label?.th || ""
  }))
);
</script>
